import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { Order } from 'order/interfaces/Order';

import { userPermissionsValues } from 'shared/enum/userPermissionsEnum';
import { SpecialOrderApprovalStatusEnum } from 'order/wizard/orderAcknowledgement/enums/SpecialOrderApprovalStatusEnum';
import { ACKStatusEnum } from 'order/wizard/orderAcknowledgement/enums/ACKStatusEnum';
import { useHasPermissions } from './useHasPermissions';

export const useDisableCollaborationActions = () => {
  const latestACK = useSelector(
    (state: RootState) => state.ACKReducer.latestACK
  );

  const specialOrderApproval = useSelector(
    (state: RootState) => state.orderReducer.order?.specialOrderApproval
  );

  const isUserCSR = useHasPermissions(
    userPermissionsValues.CSR_VIEW_ORDERBOARD
  );

  const canSendACK = useHasPermissions(
    userPermissionsValues.ACKNOWLEDGEMENT_SEND
  );

  const isCurrentUserViewer = useSelector(
    (state: RootState) => state.orderReducer.isCurrentUserViewer
  );

  const { acknowledgementStatus } = useSelector(
    (state: RootState) => state.orderReducer.order ?? ({} as Order)
  );

  const isFinishReqDisable =
    !isUserCSR &&
    !((acknowledgementStatus ?? 0) === ACKStatusEnum.CHANGES_REQUESTED);

  const isAckReqDisable =
    !isUserCSR &&
    ((!isCurrentUserViewer &&
      specialOrderApproval?.status ===
        SpecialOrderApprovalStatusEnum.PENDING) ||
      (!isCurrentUserViewer &&
        latestACK?.status === ACKStatusEnum.PENDING &&
        !canSendACK));

  return {
    isFinishReqDisable,
    isAckReqDisable,
  };
};
